// extracted by css-extract-rspack-plugin
export default {"heading":"R717qO4KUvs84CNQ","fieldGroup":"tmZbGRxy__Akx_qv"};